namespace Serenity.EmailClient {

    @Decorators.registerEditor("Serenity.EmailClient.EmailSuggestEditor")
    @Decorators.element('<input type="text"/>')
    export class EmailSuggestEditor extends Serenity.Widget<EmailSuggestEditorOptions> {

        constructor(element: JQuery, opt: EmailSuggestEditorOptions) {
            super(element, opt);

            element.attr("autocomplete", "off");

            function split(val: string) {
                return val.split(';');
            }

            function extractLast(term: string) {
                return split(term).pop();
            }

            element.autocomplete({
                minLength: 0,
                source: function (request: any, response: any) {
                    EmailService.Suggest({
                        ContainsText: extractLast(request.term)
                    }, r => {
                        response(r.Suggestions);
                    }, {
                            onError: e => {
                                response([]);
                            }
                        })
                },
                focus: function () {
                    return false;
                },
                select: function (event, ui) {
                    var terms = split(this.value);
                    terms.pop();
                    terms.push(ui.item.value);
                    terms.push("");
                    this.value = terms.join("; ");
                    return false;
                }
            });
        }
    }

    export interface EmailSuggestEditorOptions {
    }
}